import axios from 'axios';
import querystring from 'querystring';
import { uploadFileConstants as constants } from 'src/constants/uploadFileFtConstants';
import { myWayStudioServicesBaseUrl } from '../index';
import { postProxy } from '../utilis';
import {
    DeleteFileParams,
    GetFileParams,
    UploadFileParams,
    UploadFileResponse,
} from 'src/types/uploadFileFt/uploadFileApiTypes';
import { WsResponse } from 'src/types/apiCommon.types';
import { AxiosRes } from '../types';
import { GetFileResponse } from '../../types/uploadFileFt/uploadFileApiTypes';

const createUrl = (endpoint: string) => `${constants.MAIN_URL}/${endpoint}`;

const addDollarSignPrefix = (bodyObj: Object) => {
    const newObj = {};
    Object.keys(bodyObj).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        newObj[`$${key}`] = bodyObj[key];
    });
    return newObj;
};
const uploadFile = (reqBody: UploadFileParams): AxiosRes<WsResponse<UploadFileResponse>> => {
    const data = querystring.stringify({
        ...addDollarSignPrefix(reqBody),
    });
    return postProxy<WsResponse<UploadFileResponse>>(`${myWayStudioServicesBaseUrl}/MyWayUploadFile`, data);
};

const deleteFile = (reqBody: DeleteFileParams): AxiosRes<UploadFileResponse> => {
    const data = querystring.stringify({
        ...addDollarSignPrefix(reqBody),
        webservice: `MyWayApplicationsFiles/MyWayApplicationsFilesService.svc/${constants.ENDPOINTS.DELETE_FILE}`,
    });
    return postProxy<UploadFileResponse>(`${myWayStudioServicesBaseUrl}/TransitServerRequest`, data);
};

const getFile = (reqBody: GetFileParams): AxiosRes<GetFileResponse> => {
    const data = querystring.stringify({
        ...addDollarSignPrefix(reqBody),
        webservice: `MyWayApplicationsFiles/MyWayApplicationsFilesService.svc/${constants.ENDPOINTS.GET_FILE}`,
    });
    return postProxy<GetFileResponse>(`${myWayStudioServicesBaseUrl}/TransitServerRequest`, data);
};

export const uploadFilesApi = {
    reqUploadFile: uploadFile,
    reqDeleteFile: deleteFile,
    reqGetFile: getFile,
};
